"use strict";
exports.__esModule = true;
exports.checkCreds = void 0;
var Either_1 = require("fp-ts/Either");
var checkPassword_1 = require("./checkPassword");
var function_1 = require("fp-ts/function");
function checkCreds(_a) {
    var password = _a.password, googleToken = _a.googleToken, facebookToken = _a.facebookToken, appleToken = _a.appleToken;
    if (googleToken) {
        return (0, Either_1.right)({
            googleToken: googleToken,
            facebookToken: undefined,
            appleToken: undefined,
            password: undefined
        });
    }
    if (facebookToken) {
        return (0, Either_1.right)({
            googleToken: undefined,
            facebookToken: facebookToken,
            appleToken: undefined,
            password: undefined
        });
    }
    if (appleToken) {
        return (0, Either_1.right)({
            googleToken: undefined,
            facebookToken: undefined,
            appleToken: appleToken,
            password: undefined
        });
    }
    return (0, function_1.pipe)((0, checkPassword_1.checkPassword)(password), (0, Either_1.map)(function (validPassword) {
        return {
            googleToken: undefined,
            facebookToken: undefined,
            appleToken: undefined,
            password: validPassword
        };
    }));
}
exports.checkCreds = checkCreds;
//# sourceMappingURL=checkSignUpCreds.js.map